<template>
	<div id="preview_vieo" class="video-wrap" :class="{'has-more': mediaMore}">
		<!-- <vue-plyr>
		  	<video poster="poster.png" src="video.mp4">
		    	<source :src="pathView" type="video/mp4" size="720">
		    	<source :src="pathView" type="video/mp4" size="1080">
		    	<track kind="captions" label="English" srclang="en" src="captions-en.vtt" default>
		  	</video>
		</vue-plyr> -->
		<video-player  
			class="video-player-box"
			ref="videoPlayer"
			:options="playerOptions"
			customEventName="customstatechangedeventname"
			@play="onPlayerPlay($event)"
			@pause="onPlayerPause($event)"
			@ended="onPlayerEnded($event)"
			@waiting="onPlayerWaiting($event)"
			@playing="onPlayerPlaying($event)"
			@loadeddata="onPlayerLoadeddata($event)"
			@timeupdate="onPlayerTimeupdate($event)"
			@canplay="onPlayerCanplay($event)"
			@canplaythrough="onPlayerCanplaythrough($event)"
			@statechanged="playerStateChanged($event)"
			@ready="playerReadied"
        >
      	</video-player>
	</div>
</template>

<script>
	import { videoPlayer } from 'vue-video-player'
  	import 'video.js/dist/video-js.css'
  	// import { PlyrVideo } from 'vue-plyr'
	// import 'vue-plyr/dist/vue-plyr.css'

	export default {
		name: 'PreviewVideo',
		props: {
			pathView: String,
			poster: String,
			mediaMore: Boolean,
			autoPlay: Boolean
		},
		components: {
			videoPlayer,
			// PlyrVideo
		},
		data() {
			return {
				playerOptions: {
					muted: false,
					language: 'en',
					autoplay: this.autoPlay,
					playbackRates: [0.7, 1.0, 1.5, 2.0],
					width: '100%',
					sources: [{
						type: "video/mp4",
						src: this.pathView
					}],
					// poster: "/static/images/author.jpg",
				}
			}
    	},
    	mounted() {
      		// console.log('this is current player instance object', this.player)
    	},
    	computed: {
      		player() {
        		return this.$refs.videoPlayer.player
      		}
    	},
    	watch: {
    		'pathView': 'changeLinkVideo'
    	},
    	methods: {
    		changeLinkVideo() {
    			this.playerOptions.sources[0].src = this.pathView;
    		},
      		onPlayerPlay(player) {
        		// console.log('player play!', player)
      		},
			onPlayerPause(player) {
				// console.log('player pause!', player)
			},

      		// or listen state event
			playerStateChanged(playerCurrentState) {
				// console.log('player current update state', playerCurrentState)
			},

      		// player is ready
			playerReadied(player) {
				// console.log('the player is readied', player)
				// you can use it to do something...
				// player.[methods]
			},

			onPlayerPlaying(player) {
				// console.log('Playing: ', player);
			},

			onPlayerEnded(player) {
				// console.log('Ended: ', player);
			},
			onPlayerWaiting(player) {
				// console.log('Waiting: ', player);
			},
			onPlayerLoadeddata(player) {
				// console.log('Loadeddata: ', player);
			},
			onPlayerTimeupdate(player) {
				// console.log('Timeupdate: ', player);
			},
			onPlayerCanplay(player) {
				// console.log('Canplay: ', player);
			},
			onPlayerCanplaythrough(player) {
				// console.log('Canplaythrough: ', player);
			}
    	}
	}
</script>

<style lang="scss">
#preview_vieo {
	
	.video-wrap {
		// max-width: 90%;
		margin: 0 auto;
    	max-width: 100%;
	}
	.video-player-box {max-width: 100%}
	.video-js {
	    width: 100%;
	    height: auto;
	    min-height: 57vh;
	}
	.has-more {
		.video-js {
			min-height: 57vh;
			// margin-left: 30px;
		}
	}
}
</style>